import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {},
  steps: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: theme.spacing.space16,
  },
  card: {
    background:
      "linear-gradient(180deg, var(--Background-Color-bg-2, #1B2337) 0%, rgba(27, 35, 55, 0.00) 100%)",
    padding: `${theme.spacing.space8}px ${theme.spacing.space4}px`,
    borderRadius: theme.radius.small,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  desc: {
    marginTop: theme.spacing.space4,
    marginBottom: theme.spacing.space12,
    textAlign: "center",
  },
}));
